module.exports = __webpack_public_path__ + "static/the-war-nerd-a7fc82877b929484d08663be2697758e.jpg";